import React, { useCallback, useEffect, useState } from 'react'
import EditCell from './EditCell';
import LabelCell from './LabelCell';
import CellControl from './CellControl';
import useSmartRef from '../../hooks/useSmartRef';
import './Cell.css';

// TODO:  TOTAL REVIEW!...
export const SAVE_ERROR = 'SaveError';
export const REQUIRED_ERROR = 'RequiredError';
export const EDIT_ERROR = 'EditError';
export const SAVE_FIXED = 'SaveFixed';
export const EDIT_FIXED = 'EditFixed';
export const OK = 'OK';

const defaultSaveMe = async (path, content) => {
  console.log('Default NOOP saveMe [path: %s]', path);
  return true;
}

// TODO:  Implement icon + text.  (in addition to children which will only be rendered but will not serve as data)
export default function Cell({children, addError, removeError, path, saveMe = defaultSaveMe, isRequired = false, isLocked = false, isSensitive = false, validateMe = () => true, icon = '', text = '', tabIx = '1', ...rest}) {  
  const data = typeof children === 'string' ? children.trim() : children;
  //console.log('[Cell Enter] [path: %s] [children: %s] [data: %s]',path, children, data);
  
  const {get:getLastSaveError, set:setLastSaveError}   = useSmartRef(false);
  const {get:getLastEditError, set:setLastEditError}   = useSmartRef(false);
  const {get:getLastContent,  set:setLastContent}      = useSmartRef(data);    
  const [labelContent, setLabelContent]             = useState(data);  
  const [labelMode, setLabelMode]                   = useState(true);
  const [caretPos, setCaretPos]                     = useState(0);
  const [feedbackStatus, setFeedbackStatus]         = useState(OK);

  const switchMode = useCallback(() => {
    setLabelMode(prev => !prev);
  }, []);

  const preSave = useCallback( async (path, content)=>{
    const bak = getLastContent();
    
    if (content === bak) { // TODO: ALWAYS THE SAME!
      return true;
    }
    
    //console.log('[Cell preSave] [path: %s] [content: %s] [lastContent: %s]', path, content, bak);

    saveMe(path, content).then((isSaveOk) => {
      const lastSaveError = getLastSaveError();
      //console.log('[Cell preSave] [saveMe: %s]', isSaveOk);
      
      if (isSaveOk) {       // OK
        if (lastSaveError) {
          if (getLastContent()) {
            setFeedbackStatus(SAVE_FIXED);
          }
          else {
            setFeedbackStatus(OK); // RequiredFixed so just remove the error icon..
          }
        }      
        else {
          setFeedbackStatus(OK);
        }
        setLastContent(content);
        removeError(path);
        setLastSaveError(false);
      }
      else {                // ERROR
        setFeedbackStatus(SAVE_ERROR);
        addError(path);
        setLastSaveError(true);
      }        
    });

  },[saveMe, getLastContent, getLastSaveError, removeError, addError, setLastContent, setLastSaveError]);
 
  const validateSelfAndUpdateForm = useCallback((content) => {
    //console.log('[Cell validateSelfAndUpdateForm] [content: %s]', content);
    
    const isValidContent = validateMe(content, isRequired);
    const lastEditError = getLastEditError();

    if (isValidContent) { // OK
      if (lastEditError) {        
        setFeedbackStatus(EDIT_FIXED);
        removeError(path);
        setLastEditError(false);
      }
      else {
        setFeedbackStatus(OK);
        removeError(path);
        setLastEditError(false);
      }      
    }
    else {               // ERROR
      if (content) {
        setFeedbackStatus(EDIT_ERROR);
        addError(path);
        setLastEditError(true);
      }
      else {
        if (isRequired) {
          setFeedbackStatus(REQUIRED_ERROR);
          addError(path);
          setLastEditError(true);
        }
        else {
          setFeedbackStatus(OK);
          console.error('[Cell validateSelf] [content: %s] [isRequired: %s] Possible Bug: Call not mandatory but failed validation when it is empty. I am ignoring the validation since it is not mandatory but please investigate this', content, isRequired);
          removeError(path);
          setLastEditError(false);
        }        
      }
    }

  }, [addError, isRequired, path, removeError, validateMe, getLastEditError, setLastEditError]);

  //-------  REVERT   --------
  //
  const revert = useCallback(() => {
    const lastContent = getLastContent();
    // console.log('Reverting [path: '+path+' <<<--- orig: '+lastContent+']');
    setLabelContent(lastContent);
    setLastSaveError(false);
    setLastEditError(false);
    setFeedbackStatus(OK);
    removeError(path);
    validateSelfAndUpdateForm(lastContent);
  }, [getLastContent, setLastSaveError, setLastEditError, removeError, path, validateSelfAndUpdateForm]);
    

  //------[   Effect  Modes   ]------
  //
  useEffect(()=>{    
    if (isLocked) {
      setLabelMode( true );
    }

    validateSelfAndUpdateForm(data);

    setLabelContent(data);
    setLastContent(data);
  }, [validateSelfAndUpdateForm, data, isLocked, setLastContent]);

  //const cellComp = isLocked ? modes[false] : modes[mode];
  //const labelMode = Boolean(isLocked) || Boolean(!mode);
  const cellStyle = `kCell ${getLastEditError() ? 'onError' : ''}`;

  return (
    <div className={cellStyle}>
      <CellControl feedbackStatus={feedbackStatus} />
      {/* {cellComp} */}
      {labelMode && <LabelCell switchMode={switchMode}
                        setPos={setCaretPos}
                        isLocked={isLocked}
                        isSensitive={isSensitive}
                        tabIx={tabIx}
                        {...rest}>{labelContent}</LabelCell>}

      {!labelMode && <EditCell switchMode={switchMode} 
                      saveMe={preSave} 
                      revertMe={revert}  
                      path={path} 
                      setLabel={setLabelContent} 
                      carPos={caretPos} 
                      editValidateMe={validateSelfAndUpdateForm} 
                      isSensitive={isSensitive}
                      tabIx={tabIx}
                      getLastContent={getLastContent}
              {...rest}>{labelContent}</EditCell>}
    </div>
  )
}




    // const modes = {
    //   false: <LabelCell setMode={setMode} 
    //                     setPos={setCaretPos}
    //                     isLocked={isLocked}
    //                     isSensitive={isSensitive}
    //                     tabIx={tabIx}
    //           {...rest}>{labelContent}</LabelCell>,
    //   true:   <EditCell setMode={setMode} 
    //                   saveMe={preSave} 
    //                   revertMe={revert}  
    //                   path={path} 
    //                   setLabel={setLabelContent} 
    //                   carPos={caretPos} 
    //                   editValidateMe={validateSelfAndUpdateForm} 
    //                   isSensitive={isSensitive}
    //                   tabIx={tabIx}
    //                   getLastContent={getLastContent}
    //           {...rest}>{labelContent}</EditCell>
    // }


  // const [origContent, setOrigContent]               = useState(data);
  // const [saveOk, setSaveOk]                         = useState(true);
  // const [editOk, setEditOk]                         = useState(false);
  // const [saveFixed, setSaveFixed]                   = useState(false);
  // const [editFixed, setEditFixed]                   = useState(false);
